import { Portal } from 'components/Helpers';
import whatsAppIcon from 'assets/img/ws-icon.png';
import { SEARS_WHATSAPP_NUMBER, PROJECT_BASENAME } from 'constants/env';
import styles from './styles.module.scss';

const text = 'Me%20gustaría%20saber%20más%20de%20Mesa%20de%20Regalos';
const link = `${window.location.origin}${PROJECT_BASENAME}buscar-evento`;

let lastScrollTop = 0;
window.addEventListener('scroll', () => {
  const elem = document.getElementById('waText');
  if (elem) {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    scrollTop > lastScrollTop ? elem.classList.add('d-none') : elem.classList.remove('d-none');
    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  }
}, false);
const showNotPaths = ['/Mesa-de-Regalos/escanear-productos']


export default function WhatsApp() {
  // console.log(window.location.pathname)
  return (
    <Portal>
      { !showNotPaths.includes(window.location.pathname) && (
      <div className={styles.whatsAppContainer}>
        <a
          href={`https://wa.me/${SEARS_WHATSAPP_NUMBER}?text=${text}%20${link}`}
          className={`${styles.whatsApp} mb-3 pb-2 mb-lg-0 pb-lg-0`}
          target='_blank'
          rel="noreferrer"
        >
          <div id='waText' className={styles.whatsAppText}>
            <div className={styles.whatsAppTriangle} />
            <p>Contacta a un asesor</p>
          </div>
          <div className='whatsapp-icon-container'>
            <img src={whatsAppIcon} alt="whatsApp" />
          </div>
        </a>
      </div>
      )}

    </Portal>
  );
}
